import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import backgroundImage from '../../assets/home/background-home.jpg'; // Adjust the path as needed

const Home = () => (
  <div
    className="home-bg"
    style={{
      backgroundImage: `url(${backgroundImage})`,
    }}
  >
    {/* Hero Section */}
    <section className="home-hero home-hero-image-text">
      <h1 style={{ position: 'relative', zIndex: 1 }}>
        Rolling Thunder Cycles
      </h1>
      <p
        className="home-hero-desc "
        style={{ position: 'relative', zIndex: 1 }}
      >
        Long Island's Premier Harley-Davidson Service, Parts & Customization
        Shop from 1981-2025
      </p>
      <h2>Thank You for the Memories</h2>
      <p>
        While our shop doors are now closed after 44 years of service, our
        hearts remain open to the community we've served.
      </p>
      <p>
        For historical information or motorcycle consultation, you can reach out
        to us at:
        <a
          href="mailto:servicertc42@gmail.com"
          style={{ paddingLeft: '1rem' }}
        >
          servicertc42@gmail.com
        </a>
      </p>
      <Link to="/memories" className="home-cta-btn legacy">
        View Memories
      </Link>

      <Link to="/recommended-techs" className="home-cta-btn recommended-techs">
        For Service
      </Link>
    </section>
  </div>

);


export default Home;
